export class FunctionQueue {
  private queue: Function[];

  get length() {
    return this.queue.length;
  }

  constructor(functions: Function[] = []) {
    this.queue = functions;
  }

  call(value?) {
    this.queue.forEach((event) => event.call(this, value));
  }

  clear() {
    this.queue = [];
  }

  push(event) {
    this.queue.push(event);
  }

  remove(event) {
    this.queue = this.queue.filter((_) => _ !== event);
  }
}
